var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function ($html, classes, text, tooltipText) {
buf.push("<div" + (jade.attr("title", tooltipText, true, true)) + (jade.cls(['grid-edit-icon',classes], [null,true])) + "></div>" + (null == (jade_interp = $html) ? "" : jade_interp) + (jade.escape(null == (jade_interp = text) ? "" : jade_interp)));}.call(this,"$html" in locals_for_with?locals_for_with.$html:typeof $html!=="undefined"?$html:undefined,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined,"text" in locals_for_with?locals_for_with.text:typeof text!=="undefined"?text:undefined,"tooltipText" in locals_for_with?locals_for_with.tooltipText:typeof tooltipText!=="undefined"?tooltipText:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/layout/template/editable.jade
// module id = 31
// module chunks = 0